import React from 'react';
import Navbar from './components/Navbar';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAmdConditions';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About'; // Import the new About page
import ScrollToTop from './components/ScrollToTop';
import { ToastProvider } from './context/ToastContext';
import Toast from './components/Toast';
import Contact from './pages/Contact';

function App() {
  return (
    <ToastProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Helmet>
            <title>Navam Biz Solutions</title>
            <meta
              name="description"
              content="Empowering job seekers with resume enhancement and career guidance, and businesses with expert HR and recruitment solutions."
            />
            <meta name="keywords" content="Recruitment, Resume, Career Guidance, HR Solutions, Talent Acquisition" />
            <meta property="og:title" content="Navam Biz Solutions" />
            <meta
              property="og:description"
              content="Empowering job seekers with resume enhancement and career guidance, and businesses with expert HR and recruitment solutions."
            />
            <meta
              property="og:image"
              content="https://www.navambizsolutions.com/static/media/logo.8676f5d632e666acb2b8.png"
            />
            <meta property="og:url" content="https://www.navambizsolutions.com" />
            <meta property="og:type" content="website" />
          </Helmet>

          <Navbar className="relative z-50" />

          <main className="container mx-auto my-10 px-4">
            <Routes>
              <Route path="/home" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsAndConditions />} />
            </Routes>
          </main>
          <Toast />
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;